import React, { useState } from "react";
import { Flex, Heading, Text } from "rebass";
import BlurredText from "../blurredText";
import Button from "../button";

const BlurredBlocks = ({ blocks, onBlockClick = () => null, ...props }) => {
	const [activeBlock, setActiveBlock] = useState([0, 1]);

	return (
		<Flex
			flexWrap={[null, null, "wrap"]}
			flexDirection={['column', null, 'row']}
			justifyContent="flex-start"
			alignItems={['stretch', null, 'flex-start']}
			maxWidth={[null, null, 850, 1000]}
			width="100%"
			px={[3, null, 0]}
			pb={[5, null, 0]}
			{...props}
		>
			{blocks.map(({ content, id, title, description, link }, i) => {
				const order = [0, 2, 1].indexOf(i);
				return (
					<BlurredText
						active={activeBlock[0] === i}
						past={activeBlock[1] === i}
						key={id}
						flexDirection="column"
						alignItems={[order % 2 ? 'flex-end' : 'flex-start', null, i === 1 ? 'flex-end' : 'flex-start']}
						pl={[null, null, i === 0 ? 5 : (i === 1 ? 3 : 0), i === 0 ? 6 : (i === 1 ? 4 : 0)]}
						pr={[null, null, i === 2 ? 3 : 0, i === 2 ? 4 : 0]}
						mt={[null, null, i === 2 ? 5 : 0, i === 2 ? 6 : 0]}
						onMouseEnter={() => setActiveBlock(
							([lastActive]) => [i, lastActive !== i ? lastActive : (lastActive + 1) % blocks.length]
						)}
						mb={[4, null, 0]}
						onClick={() => onBlockClick(id)}
						sx={{ willChange: 'filter', flexBasis: i === 0 ? '100%' : '50%', order }}
					>
						<Flex
							mt={3}
							flexDirection="column"
							alignItems={[order % 2 ? 'flex-end' : 'flex-start', null, "flex-start"]}
							sx={{ textAlign: [order % 2 ? 'right' : 'left', null, "left"] }}
						>
							<Heading as="h2" fontSize={[6, null, null, 7]}>{title}</Heading>
							<Text fontSize={1} maxWidth={[null, null, 320]} mt={[20]}>{description}</Text>
							{link ? (<Button sx={{ mt: 3, alignSelf: [null, null, 'flex-end']}}>{link}</Button>) : null}
						</Flex>
					</BlurredText>
				) })}
		</Flex>
	)
};

export default BlurredBlocks;
